import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/69fcc5f4f6558f00142fd58f/satvocab/src/app/page.tsx");
